<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div class="containerIconLeft" @click="linkBackTo(content)">
              <font-awesome-icon icon="chevron-left" class="IconLeft" />
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CRow>
            <CCol col="12">
              <CardContent :cardContent="content" @nextRoute="nextRoute" />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="1">
          <div class="containerIconRight" @click="linkNextTo(content)">
            <font-awesome-icon
              v-if="!loading"
              icon="chevron-right"
              class="IconRight"
            />
            <font-awesome-icon
              v-if="loading"
              icon="spinner"
              class="IconRight"
            />
          </div>
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardContent from "../../components/template/Chinese1/CardContent";
import CardPopupImg from "../../components/template/Chinese1/CardPopupImg";
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { CardContent, CardPopupImg, LoadingMDL },
  name: "CTA04",
  data() {
    return {
      content: {},
      lang: this.$store.getters["language/getLanguage"],
      pageCode: "",
      baseURL: "CTA04-",
      isModalVisible: false,
      popupData: {},
      cardType: "img",
      isChange: false,
      newPath: "",
      CheckWidth: window.innerWidth.toString(),
      courseCode: "",
      topicId: "",
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      isCompletedLoad: false,
      courseSection: "",
      startTime: "",
      condition: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      storeLanguage: "language/getLanguage",
      getUserTemplate: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
      getCourseChapterAndProgress: "template/getCourseChapterAndProgress",
    }),
  },

  watch: {
    allCourse: function (val) {
      if (!val.enable) {
        alert("Access denied!");
        var url = this.$helpers.updatePathCHN(val.navigate.close.action);
        this.$router.push(url);
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
      this.loading = false;
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
    getUserTemplate: function (val) {
      this.userTemplateData = val;
      this.condition.push({
        criteria: val.data.condition.criteriaType[0]._id,
        val: val.data.condition.criteriaType[0].val,
      });
      this.loading = false;
    },
    loadingGetter: function (val) {
      if (val == true) {
        this.isCompletedLoad = !this.isCompletedLoad;
      }
    },
    isCompletedLoad: function () {
      let str = this.nextAction.split("-");
      let body = "/" + str[0] + "/" + str[1];
      this.$store.commit("necessary/setCodePage", str[1]);
      if (this.getParams == 3) {
        this.$router.push(body);
      } else if (this.getParams > 3 && this.getParams < 7) {
        let bodyFetch = {};
        bodyFetch.code = this.courseCode;
        bodyFetch.templateCode = this.nextAction;
        this.$store.dispatch("template/fetchContent", bodyFetch);

        this.$router.push(body);
      } else if (
        this.getParams == 7 ||
        this.getParams == 17 ||
        this.getParams == 20 ||
        this.getParams == 24
      ) {
        this.$router.push(body);
      } else if (str[0] === "CTA04") {
        let bodyFetch = {};
        bodyFetch.code = this.courseCode;
        bodyFetch.templateCode = this.nextAction;
        this.$store.dispatch("template/fetchContent", bodyFetch);
        this.$router.push(body);
      } else {
        this.$router.push(body);
      }
      this.loading = false;
    },
  },

  mounted() {},

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.getParams = this.$route.params.id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
    let body = {};
    body.code = this.courseCode;
    body.templateCode = "CTA04-" + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
    this.$store.dispatch(
      "courses/fetchCourseChapterAndProgress",
      this.courseCode
    );
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    nextRoute(path) {
      if (path.type == undefined) {
        let str = path.path.split("-");
        this.$router.push("/" + str[0] + "/" + str[1]);
      }
    },
    returnData(str) {
      this.isChange = true;
      this.newPath = str[0] + "-" + str[1];
    },
    linkNextTo(path) {
      this.loading = true;
      this.nextAction = path.navigate.next.action;
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
    },
    linkBackTo(path) {
      let str = path.navigate.previous.action.split("-");
      var pathCheck = str[0];
      let body = "/" + str[0] + "/" + str[1];
      this.$store.commit("necessary/setCodePage", str[1]);
      if (pathCheck === "CTA04") {
        this.loading = true;
        let bodyFetch = {};
        bodyFetch.code = this.courseCode;
        bodyFetch.templateCode = path.navigate.previous.action;
        this.$store.dispatch("template/fetchContent", bodyFetch);
        this.$router.push(body);
      } else {
        this.$router.push(body);
      }
    },
  },
};
</script>
<style></style>
